<div class="productivity-content d-flex justify-content-center">
  <div class="productivity-clipboard d-flex flex-column" *ngIf="!accumulated?.length && hasAccumulated">
    <img src="./assets/icon/pick/clipboard.svg" width="30" alt="clipboard" />
    <p>Ingresa un fecha o rango de fecha para mostrar los resultados</p>
  </div>
  <mat-accordion class="w-100" *ngIf="accumulated?.length > 0 && hasAccumulated">
    <mat-expansion-panel [expanded]="!hasDetail" (opened)="onOpened()">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Acumulados
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-picking-productivity-table [data]="accumulated" [searchFilter]="searchFilter"></app-picking-productivity-table>
    </mat-expansion-panel>
    <app-picking-productivity-table [data]="accumulatedTotal" [searchFilter]="searchFilter" *ngIf="hasDetail"></app-picking-productivity-table>
    <mat-expansion-panel (opened)="onOpenedDetail()">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Detalle
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="content-productivity-detail">
        <app-picking-productivity-table [data]="accumulatedDetail" [searchFilter]="searchFilter" [hasDetail]="hasDetail" [sticky]="true"></app-picking-productivity-table>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <ng-container *ngIf="!hasAccumulated">
    <app-picking-productivity-table [data]="accumulatedDetail" [searchFilter]="searchFilter" [hasDetail]="true"></app-picking-productivity-table>
  </ng-container>
</div>